// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__3AQVO","content":"GlobalSearch_content__2mn36"};